






















import Vue from 'vue';
import router from '@/router'
import { client, appSettings } from '@/util';

export default Vue.extend({
    data() {
        return {
            currentSentinelDeployments: [],
            mouselocation: [],
            appsettings : appSettings,
            isGraph: false,
        }
    },
    created() {
        client.post("/public/myrtle/deployments/current").then((result) => {
            this.currentSentinelDeployments = result.data.rows;
        })
    },
    methods: {
        deploymentClicked(deploymentId: number) {
            router.push("/dashboard/graphs/deployment/" + deploymentId);
            // console.log(this.sentinelDeployments);
        },
        fmtDate(datetime: string): string {
            const re = /^(\d{4})-(\d{2})-(\d{2})/
            const match = re.exec(datetime)
            console.log(match)
            if (match != null) {
                return match[3] + "/" + match[2] + "/" + match[1]
            } else {
                return datetime
            }
        },
        MapUrl(deploymentId: number){
            return this.appsettings.backendUrl + "/public/deployment-map-image/" + deploymentId
        }
    }
});
